<template>
  <form class="default-form" @submit.prevent="validateForm">
    <div class="form-group" v-if="!loginWithPhoneNumber">
      <label>{{ _T('Email') }}</label>
      <input
        required
        v-model="login"
        type="text"
        class="form-control custom-input"
        value=""
        :placeholder="_T('Email')"
        autocomplete="new-password"
      />
    </div>
    <div class="form-group" v-if="loginWithPhoneNumber">
      <label>{{ _T('Phone Number') }}</label>
      <phone-number-input @custom-input="payload => (phone_number = payload)" />
    </div>
    <div class="form-group">
      <label>{{ _T('Password') }}</label>
      <div class="input-group mb-3">
        <input
          required
          v-model="password"
          class="form-control custom-input"
          value=""
          :type="showPassword ? 'text' : 'password'"
          :placeholder="_T('Enter your password')"
          autocomplete="new-password"
        />
        <div class="input-group-append">
          <span class="input-group-text" @click="showPassword = !showPassword">
            <img src="/images/svg/account/eye.svg" alt=""
          /></span>
        </div>
      </div>
      <div class="remember">
        <label class="d-sm-none d-lg-inline-block">
          <input class="checkbox_animated" type="checkbox" checked />
          {{ _T('Remember me') }}
        </label>
        <a
          href="javascript:void(0)"
          @click.prevent="$bvModal.show('forgot-password')"
        >
          {{ _T('Forgot Password') }}?
        </a>
      </div>
    </div>
    <div class="checkout-buttons">
      <button
        type="button"
        class="btn btn-outline btn-block"
        @click.prevent="loginWithPhoneNumber = !loginWithPhoneNumber"
      >
        {{
          loginWithPhoneNumber ? _T('Login with Email') : _T('Login with Phone')
        }}
      </button>
      <progress-bar
        v-if="processInProgress(process)"
        :btn-large="true"
        :ui-block="true"
      />
      <button v-else type="submit" class="btn btn-solid btn-block second-btn">
        {{ _T('Login') }}
      </button>
    </div>
    <button class="btn btn-outline btn-block mt-2" @click="guestCheckout(true)">
      {{ _T('Guest Checkout') }}
    </button>
    <div
      v-if="login_fail_message || login_success_message"
      class="alert fade show mt-3"
      :class="
        login_fail_message
          ? 'alert-danger'
          : login_success_message
          ? 'alert-success'
          : ''
      "
      role="alert"
    >
      {{
        login_fail_message
          ? login_fail_message
          : login_success_message
          ? login_success_message
          : ''
      }}
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import { validateEmail, validatePhoneNumber } from '@/utils/main_utils'

export default {
  name: 'CheckoutAsRegisteredUser',
  data: () => ({
    login: '',
    password: '',
    process: 'checkout_login',
    showPassword: false,
    loginWithPhoneNumber: false,
    phone_number: '',
  }),
  computed: {
    ...mapGetters([
      'login_success_message',
      'login_fail_message',
      'login_in_progress',
      'processInProgress',
      '_T',
    ]),
  },
  watch: {
    login() {
      this.$store.dispatch('set_login_failure_message', '')
    },
  },
  methods: {
    validateForm() {
      let errorsCount = 0
      if (!this.loginWithPhoneNumber) {
        if (!validateEmail(this.login)) {
          this.setLoginFailureMessage(this._T('Incorrectly formatted email'))
          errorsCount = 1
        }
      } else {
        if (!validatePhoneNumber(this.phone_number)) {
          this.setLoginFailureMessage(this._T('Incorrectly formatted phone number'))
          errorsCount = 1
        }
      }
      if (!this.password.trim()) {
        this.setLoginFailureMessage('Password is required')
        errorsCount = 1
      }
      if (errorsCount === 0) {
        this.login_action()
      }
    },
    setLoginFailureMessage(message) {
      this.$store.dispatch('set_login_failure_message', this._T(message))
    },
    login_action() {
      if (
        this.login_in_progress == false &&
        !this.processInProgress(this.process)
      ) {
        let login = ''
        if (this.loginWithPhoneNumber) {
          login = this.phone_number
            .toString()
            .replace(/\+/g, '')
            .replace(/\s/g, '')
        } else {
          login = this.login.toString().toLowerCase()
        }
        this.$store.dispatch('startProcess', {
          process: this.process,
          progress: true,
        })
        this.$store
          .dispatch('login', {
            login,
            password: this.password,
          })
          .then(() => {})
          .catch(() => {
            this.$store.dispatch(
              'set_login_failure_message',
              this._T('Invalid credentials')
            )
          })
          .finally(() => {
            this.$store.dispatch('stopProcess', this.process)
          })
      }
    },
    guestCheckout(opt) {
      this.$store.commit('SET_GUEST_CHECKOUT', opt)
    },
  },
  components: {
    ProgressBar: () => import('@/components/Elements/ProgressBar'),
    PhoneNumberInput: () =>
      import('@/components/Elements/PhoneNumberInput.vue'),
  },
}
</script>

<style lang="scss" scoped>
.default-form {
  .form-group {
    .custom-input {
      &::placeholder,
      &:-ms-input-placeholder,
      &::-ms-input-placeholder {
        color: rgba(var(--color-black-source), 0.5);
        opacity: 0.5;
        font-weight: normal;
      }
    }
    .remember {
      padding-bottom: $px5;
      label {
        color: $color-primary;
        font-weight: 500;
        margin-bottom: 0;
      }
      a {
        float: right;
      }
    }
  }
  .checkout-buttons {
    display: grid !important;
    grid-template-columns: 49% 49%;
    grid-column-gap: 2%;
    .btn-block {
      margin-top: 0 !important;
    }
    @media (max-width: 575px) {
      grid-template-columns: 1fr;
      grid-row-gap: $px10;
    }
    .second-btn {
      grid-column: 2;
      grid-row: 1;
    }
  }
}
.body-rtl {
  @media (max-width: 767px) {
     .remember {
        text-align: left;
      }
  }
  .default-form {
    .form-group {
      .input-group {
        input {
            border-left: none;
            border-right: 1px #edeff4 solid;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-top-right-radius: .375rem;
            border-bottom-right-radius: .375rem;
          }
          .input-group-append {
            .input-group-text {
              border-right: none;
              border-left: 1px #edeff4 solid;
              border-top-right-radius: 0;
              border-bottom-right-radius: 0;
          }
        }
      }
    }
  }
}
</style>
